// ** React Imports
import React, { useEffect, useState } from 'react'

// ** MUI Imports

// ** Utils and Child Imports
import { Button } from '@mui/material'
import { Filter } from 'react-feather'
import { DataFilterConfigType, FilterDataType } from 'src/lib/types/filters'
import FilterFormDialog from './FilterFormDialog'

interface FloFiltersProps {
  isQueryBasedFilter?: boolean
  startDate: string
  endDate: string
  isDisabled?: boolean
  filterConfig: DataFilterConfigType
  initialFilterData: FilterDataType[]
  filterArrayData: FilterDataType[] | undefined
  setFilterArrayData: any
  handleApplyFilters?: any
  buttonClassName?: string
}

const FloFilters: React.FC<FloFiltersProps> = ({
  isQueryBasedFilter = true,
  startDate,
  endDate,
  isDisabled = false,
  filterConfig,
  initialFilterData,
  filterArrayData,
  setFilterArrayData,
  handleApplyFilters,
  buttonClassName
}) => {
  const [isOpenFilterDialog, setOpenFilterDialog] = useState<boolean>(false)
  const [localFilterData, setLocalFilterData] = useState<FilterDataType[] | undefined>()

  useEffect(() => {
    if (!filterArrayData) return
    setLocalFilterData(filterArrayData)
  }, [filterArrayData])

  const handleApplyClick = () => {
    setFilterArrayData(localFilterData)
    handleApplyFilters && handleApplyFilters(localFilterData)
    setOpenFilterDialog(false)
  }

  return (
    <>
      <button
        disabled={isDisabled}
        className={buttonClassName ?? 'flex items-center gap-1 px-3 py-2 text-sm font-semibold transition duration-200 bg-white border rounded whitespace-nowrap h-9 border-gray-light hover:border-coal-lighter'}
        onClick={() => setOpenFilterDialog(true)}
      >
        <Filter className='text-[#6e6e6e] w-4' />
      </button>

      {isOpenFilterDialog ? (
        <FilterFormDialog
          isQueryBasedFilter={isQueryBasedFilter}
          primaryButton={'Apply'}
          secondaryButton={'Cancel'}
          isDialogOpen={isOpenFilterDialog}
          setIsDialogOpen={setOpenFilterDialog}
          title={'Manage filters'}
          filterConfig={filterConfig}
          initialFilterData={initialFilterData}
          filterArrayData={localFilterData}
          setFilterArrayData={setLocalFilterData}
          startDate={startDate}
          endDate={endDate}
          handleApplyFilters={handleApplyClick}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default FloFilters
